import { captureException } from '@sentry/react';
import { useGlobal } from './useGlobal';

export const PORTFOLIO_API_PREFIX = { v1: 'api/portfolio/v1' };

export const useAPIRoute = (
    route: string,
    version: keyof typeof PORTFOLIO_API_PREFIX = 'v1'
) => {
    const { apiBaseUrl } = useGlobal();

    if (!apiBaseUrl?.length) {
        captureException(new Error(`No API base URL - cannot contact server`));
        throw new Error(`Cannot contact server`);
    }

    const normalizedBaseUrl = apiBaseUrl.replace(/\/*$/, '');

    return `${normalizedBaseUrl}/${PORTFOLIO_API_PREFIX[version]}/${route}`;
};
